import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import {
  TableContainer,
  Table,
  TableBody,
  TableCell,
  Box,
  Button,
  Grid,
} from '@material-ui/core';
import TablePagination from '@material-ui/core/TablePagination';
import ClientService from '../../services/ClientService.jsx';
// import InvitesTable from './InvitesTable.jsx';

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      margin: '0 5px',
    },
  },
  table: {
    minWidth: 650,
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
}));

export default function Newsletters() {
  const classes = useStyles();
  const [data, setData] = useState([]);
  const [dataFetching, setDataFetching] = useState(false);
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const loadInvites = async () => {
    try {
      setDataFetching(true);
      const invites = await ClientService.getInvites();
      setData(invites.sort((a, b) => (a.id - b.id)));
      setDataFetching(false);
    } catch (err) {
      setDataFetching(false);
      throw new Error(err.message);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = data.map((n) => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    setSelected(newSelected);
  };

  const loadText = (data.length !== 0) ? 'Reload' : 'Load';

  const invites = data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  const emptyRows = rowsPerPage - Math.min(rowsPerPage, invites.length - page * rowsPerPage);

  const isSelected = (id) => selected.indexOf(id) !== -1;

  return (
    <React.Fragment>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Paper className={classes.paper} elevation={0} variant="outlined">
            <div className={classes.root}>
            <Button variant="contained" color="primary" onClick={loadInvites} disabled={dataFetching}>{(!dataFetching) ? loadText : 'Loading...'}</Button>
            </div>
          </Paper>
        </Grid>
        <Grid item xs={12}>
          <TableContainer component={Paper} variant="outlined">
            {/* <Table className={classes.table}>
              <InvitesTable
                data={invites}
                page={page}
                rowsPerPage={rowsPerPage}
                emptyRows={emptyRows}
                isSelected={isSelected}
                numSelected={selected.length}
                rowCount={data.length}
                onSelectAllClick={handleSelectAllClick}
                handleRowClick={handleClick}
              />
            </Table>
            <TablePagination
            rowsPerPageOptions={[10, 15, 20]}
            component="div"
            count={invites.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
          /> */}
          </TableContainer>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
